var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('router-view',{staticClass:"app-route-placement"}),_c('LoginModal'),_c('Toaster'),_c('HelpAndSupport',{attrs:{"isShowModal":_vm.isShowHelpModal}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }